import { Component, Input } from '@angular/core';

@Component({
  selector: 'partner-bank-account-list-view',
  templateUrl: './partner-bank-account-list-view.component.html',
  styleUrls: ['./partner-bank-account-list-view.component.scss'],
  standalone: false,
})
export class PartnerBankAccountListViewComponent {
  @Input() public bankAccounts: app.models.BankAccountProfileModel[];
}
